import { WindowType } from '../../types/global-window-type';
import { sendEventToHelpAnywherePanel } from './help-panel-events';

/* eslint-disable @typescript-eslint/no-explicit-any */
let liveDesignTimeout: any;

declare const window: WindowType;
export const populateLiveDesignLink = () => {
  window.addEventListener('getLiveDesignURLLink', (e: any) => {
    console.info('Studio getLiveDesignURLLink', e);
    if (e.detail) {
      window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields({ liveDesignURL: `https://${e.detail}` });
    }
  });
  window.dispatchEvent(new CustomEvent('generateLiveDesignLinkEvent'));
};

export const clearDesignLinkTimeOut = () => {
  clearTimeout(liveDesignTimeout);
};

export const handleStudioHelpPanel = (openPanel = false) => {
  if (openPanel) {
    sendEventToHelpAnywherePanel('showHelpPanel');
  } else {
    sendEventToHelpAnywherePanel('showHelpPanelButton');
  }
};
